import React from 'react'

function Contact() {
  return (
    <>
      <div className="dr-header">
        <div className="header-contant">
          <h1>Contact Us</h1>
          <p>Doctor {" > "} Contact Us</p>
        </div>
      </div>

      <div className="contact">
        <div className="contact-row">
          <div className="contact-col">
            <h2>Our Clinic Information</h2>

            <div className="contact-col-l con-bor">
              <i className="fa-solid fa-location-dot" />
              <div className="contact-cont">
                <h5>Location</h5>
                <p style={{ textTransform: "capitalize" }}>
                  Root AND Tooth Dental Clinic
                  <br /> Shop no 1 and 2, first floor shree ram palace, next to khedapati mandir balaji nagar. Landmark in front of kanta shravan hotel, Bhopal (462021).
                </p>
                <iframe
                  title="maplink"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14661.646206897667!2d77.4463915!3d23.2644911!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397c694562b9bb21%3A0xfb0f052048cabf4f!2sRoot%20N%20Tooth%20Skin%20Hair%20and%20Dental%20Clinic!5e0!3m2!1sen!2sin!4v1773821002888!5m2!1sen!2sin"
                  width="100%"
                  height="250"
                  style={{ border: 0 }}
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>

            <div className="contact-col-l con-bor">
              <i className="fa-solid fa-phone-volume" />
              <div>
                <h5>Call Us</h5>
                <p>
                  <a href="tel:7771949867">+91-7771949867</a>
                </p>
              </div>
            </div>

            <div className="contact-col-l">
              <i className="fa-solid fa-envelope" />
              <div>
                <h5>Email</h5>
                <p>
                  <a href="mailto:rootntoothdentalclinic@gmail.com">
                    rootntoothdentalclinic@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="contact-col contact-col-r">
            <h1>Enquiry Now</h1>

            <form
              action="mailto:rootntoothdentalclinic@gmail.com"
              method="post"
              encType="text/plain"
            >
              <div className="row">
                <div className="col">
                  <input
                    type="text"
                    name="Name"
                    className="form-control"
                    placeholder="Your Name*"
                    aria-label="Your Name"
                    autoComplete="off"
                  />
                </div>

                <div className="col">
                  <input
                    type="tel"
                    name="Phone"
                    className="form-control"
                    placeholder="Your Phone"
                    aria-label="Your Phone"
                    autoComplete="off"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <input
                    type="email"
                    name="Email"
                    className="form-control"
                    placeholder="Your Email*"
                    aria-label="Your Email"
                    autoComplete="off"
                  />
                </div>

                <div className="col">
                  <input
                    type="text"
                    name="Subject"
                    className="form-control"
                    placeholder="Subject"
                    aria-label="Subject"
                    autoComplete="off"
                  />
                </div>
              </div>

              <div className="form-floating">
                <textarea
                  name="Message"
                  className="form-control"
                  placeholder="Message"
                  id="floatingTextarea"
                  style={{ height: 120 }}
                />
                <label htmlFor="floatingTextarea">Message</label>
              </div>

              <div className="send-msg">
                <button type="submit">SEND MESSAGE</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default Contact;
